import { render, staticRenderFns } from "./basicParameter.vue?vue&type=template&id=654a7327"
import script from "./basicParameter.vue?vue&type=script&lang=js"
export * from "./basicParameter.vue?vue&type=script&lang=js"
import style0 from "./basicParameter.vue?vue&type=style&index=0&id=654a7327&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('654a7327')) {
      api.createRecord('654a7327', component.options)
    } else {
      api.reload('654a7327', component.options)
    }
    module.hot.accept("./basicParameter.vue?vue&type=template&id=654a7327", function () {
      api.rerender('654a7327', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/productDetail/basicParameter.vue"
export default component.exports